import React from 'react';
import { Brain } from 'lucide-react';
import { useStore } from '../store/useStore';

export const ReasoningLoader: React.FC = () => {
  const { language } = useStore();
  
  return (
    <div className="flex justify-start ml-16">
      <div className="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm border border-gray-200 dark:bg-gray-700 dark:border-gray-600">
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 dark:bg-orange-900">
          <Brain className="w-5 h-5 text-orange-600 dark:text-orange-300" />
        </div>
        <span className="text-gray-700 dark:text-gray-300 animate-pulse">
          {language === 'es' ? 'Razonando...' : 'Reasoning...'}
        </span>
      </div>
    </div>
  );
};